import { ReactNode } from "react";

import { Tag, TagType } from "capitalrx-components-2.0/lib/general";

/** The environment tag component. */
export const EnvironmentTag = (): ReactNode => {
  let type;
  let content;

  const environment = site?.useAnalyticsAPIEnv?.toLowerCase?.();

  switch (environment) {
    case "staging":
    case "primestaging":
      type = "success";
      content = "Staging";
      break;
    case "uat":
    case "primeuat":
      type = "error";
      content = "UAT";
      break;
    case "qa":
    case "primeqa":
      type = "warning";
      content = "QA";
      break;
    case "training":
      type = "system-alternative";
      content = "Training";
      break;
    default:
      type = null;
      content = null;
      break;
  }

  return (
    type
    && content && (
      <Tag type={`${type}-high-contrast` as TagType} testId="environment-tag">
        {content}
      </Tag>
    )
  );
};
